import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { onlyUpdateForKeys } from 'recompose';

import { Button } from 'components';
import { T } from 'containers';
import { AppText } from 'domain/appText';

const MyButton = styled(Button)`
  margin-right: 30px;
  margin-left: 30px;
  width: auto;
  background-color: #335b80;
  border: 1px solid #335b80;
  font-weight: 400;
  font-size: 15px;
  position: relative;
  line-height: 24px;
  padding: 16px 20px 16px 55px;
  color: #fff;
  border-radius: 4px;
  text-align: left;
  display: inline-block;

  &:hover{
    background: #fff;
    border: 1px solid #d5e2ed;
    box-shadow: none;
    color: #335b80;

    img.dark{
      display: inline-block;
    }

    img.light{
      display: none;
    }
  }
  
  &.sticky {
    position: fixed!important;
    right: 125px;
    top: 5px;
    z-index: 200;
  }

  span{
    width: 40px;
    height: 56px;
    position: absolute;
    left: 0px;
    top: 0px;
    border-radius: 3px 0 0 3px;
  }
  img{
    width: 32px;
    height: 32px;
    margin: 12px 0px 12px 16px;
    display: inline-block;
  }

  img.dark{
    display: none;
  }
`;

const ManageAllButton = onlyUpdateForKeys([])(({ onClick }) => (
  <T
    text={AppText.CabinDistributionButtonText}
    render={translation => (
      <MyButton className="manage-all-cabins-button" onClick={onClick}><span><img src="/assets/images/cabin_white.svg" alt="{translation}" className="light" /><img src="/assets/images/cabin.svg" className="dark" alt="{translation}" /></span>{translation}</MyButton>
    )}
  />
));
ManageAllButton.propTypes = {
  onClick: PropTypes.func,
};
ManageAllButton.defaultProps = {
  onClick: () => {},
};

export default ManageAllButton;



// WEBPACK FOOTER //
// ./src/components/molecules/ManageAllButton/index.js